'use client';

import { createTheme } from '@mui/material/styles';
import { Roboto } from 'next/font/google';

const roboto = Roboto({
  weight: ['300', '400', '500', '700'],
  subsets: ['latin'],
  display: 'swap',
});

declare module '@mui/material/styles' {
  interface TypographyVariants {
    customH4: React.CSSProperties;
  }
  interface TypographyVariantsOptions {
    customH4?: React.CSSProperties;
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    customH4: true;
  }
}

const theme = createTheme({
  colorSchemes: { light: true },
  cssVariables: {
    colorSchemeSelector: 'class',
  },
  typography: {
    fontFamily: roboto.style.fontFamily,
    customH4: {
      fontWeight: 700, 
      fontSize: 24, 
      color: '#153C7F', 
      fontFamily: 'Poppins, sans-serif',
      letterSpacing: '-0.5px',
      marginBottom: '1.5rem',
      textTransform: 'uppercase',
    },
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#4D4D4D',
          color: '#F3F1FF',
          fontFamily: 'Poppins, sans-serif',
          fontSize: '16px',
          padding: '12px 16px',
          borderRadius: '8px',
          maxWidth: '300px',
          lineHeight: 1.5,
        },
        arrow: {
          color: '#4D4D4D',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: { severity: 'info' },
              style: {
                backgroundColor: '#60a5fa',
              },
            },
          ],
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        // Customize contained button
        containedPrimary: {
          backgroundColor: '#59A80F', // Ensure primary color
          '&:hover': {
            backgroundColor: '#59A80F', // Darker shade on hover
          },
        },
        // Customize outlined button
        outlinedPrimary: {
          borderColor: '#59A80F',
          color: '#59A80F',
          '&:hover': {
            backgroundColor: 'unset', // Light background on hover
          },
        },
      },
    },
  },
});

export default theme;